import React from 'react'
import { CircularProgress, Paper, Typography } from '@material-ui/core'
import { useTranslation } from '@/langs/useTranslation'
import { FormItem } from '@/components/Form'
import { ImageUploader, TextInput } from './Compo'

const Platform = ({ value, onChange, loading }) => {
  const { t, langConf } = useTranslation()

  return (
    <Paper elevation={0} style={{ backgroundColor: "#F8F9FC", borderRadius: "10px", marginTop: 24 }}>
      <Typography variant="h5" style={{ marginBottom: 24 }}>
        3. {t({ defaultMessage: "编辑 Platform" })}
        {loading && <CircularProgress size={22} style={{marginLeft: 16}} />}
      </Typography>
      <TextInput
        number="3.1"
        title={t({ defaultMessage: "Platform 介绍" })}
        value={value.introduce}
        name="platform.introduce"
        placeholder={langConf.platform?.text || t({ defaultMessage: "例：全球服务，创造您的想象力，提供智能体验" })}
        onChange={onChange}
        disabled={loading}
      />
      <ImageUploader
        number="3.2"
        title={t({ defaultMessage: "账号中心上传" })}
        value={value.accountCenterIcon}
        name="platform.accountCenterIcon"
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.accountCenterText}
        name="platform.accountCenterText"
        placeholder={t({ defaultMessage: "例：账号中心" })}
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.accountCenterTip}
        name="platform.accountCenterTip"
        placeholder={t({ defaultMessage: "例：为您的工作伙伴与客户管理账号" })}
        onChange={onChange}
        disabled={loading}
      />

      <ImageUploader
        number="3.3"
        title={t({ defaultMessage: "设备管理上传" })}
        value={value.deviceManagementIcon}
        name="platform.deviceManagementIcon"
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.deviceManagementText}
        name="platform.deviceManagementText"
        placeholder={t({ defaultMessage: "例：设备管理" })}
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.deviceManagementTip}
        name="platform.deviceManagementTip"
        placeholder={t({ defaultMessage: "例：管理您在全世界的设备与群组" })}
        onChange={onChange}
        disabled={loading}
      />

      <ImageUploader
        number="3.4"
        title={t({ defaultMessage: "门店管理上传" })}
        value={value.merchantManagementIcon}
        name="platform.merchantManagementIcon"
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.merchantManagementText}
        name="platform.merchantManagementText"
        placeholder={t({ defaultMessage: "例：门店管理" })}
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.merchantManagementTip}
        name="platform.merchantManagementTip"
        placeholder={t({ defaultMessage: "例：门店和账户管理" })}
        onChange={onChange}
        disabled={loading}
      />

      <ImageUploader
        number="3.5"
        title={t({ defaultMessage: "权限管理上传" })}
        value={value.accessManagementIcon}
        name="platform.accessManagementIcon"
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.accessManagementText}
        name="platform.accessManagementText"
        placeholder={t({ defaultMessage: "例：权限管理" })}
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.accessManagementTip}
        name="platform.accessManagementTip"
        placeholder={t({ defaultMessage: "例：管理Nubis平台角色使用权限" })}
        onChange={onChange}
        disabled={loading}
      />

      <ImageUploader
        number="3.6"
        title={t({ defaultMessage: "设备中心上传" })}
        value={value.deviceCenterIcon}
        name="platform.deviceCenterIcon"
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.deviceCenterText}
        name="platform.deviceCenterText"
        placeholder={t({ defaultMessage: "例：设备中心" })}
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.deviceCenterTip}
        name="platform.deviceCenterTip"
        placeholder={t({ defaultMessage: "例：管理设备、监控、远程操控设备等" })}
        onChange={onChange}
        disabled={loading}
      />

      <ImageUploader
        number="3.7"
        title={t({ defaultMessage: "公告管理上传" })}
        value={value.announcementManagementIcon}
        name="platform.announcementManagementIcon"
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.announcementManagementText}
        name="platform.announcementManagementText"
        placeholder={t({ defaultMessage: "例：公告管理" })}
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.announcementManagementTip}
        name="platform.announcementManagementTip"
        placeholder={t({ defaultMessage: "例：维护系统公共通知" })}
        onChange={onChange}
        disabled={loading}
      />

      <ImageUploader
        number="3.8"
        title={t({ defaultMessage: "升级中心上传" })}
        value={value.updateCenterIcon}
        name="platform.updateCenterIcon"
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.updateCenterText}
        name="platform.updateCenterText"
        placeholder={t({ defaultMessage: "例：升级中心" })}
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.updateCenterTip}
        name="platform.updateCenterTip"
        placeholder={t({ defaultMessage: "例：提供进版或是更新设备的image" })}
        onChange={onChange}
        disabled={loading}
      />

      <ImageUploader
        number="3.9"
        title={t({ defaultMessage: "个性化管理上传" })}
        value={value.personalizedManagementIcon}
        name="platform.personalizedManagementIcon"
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.personalizedManagementText}
        name="platform.personalizedManagementText"
        placeholder={t({ defaultMessage: "例：个性化管理" })}
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        value={value.personalizedManagementTip}
        name="platform.personalizedManagementTip"
        placeholder={t({ defaultMessage: "例：允许用户轻松自定义网站标题、图标和文本，以获得个性化的网络体验" })}
        onChange={onChange}
        disabled={loading}
      />
    </Paper>
  )
}

export default Platform